/**
 * @name ForgotPasswordDialog
 * @description Modal para recuperar contraseña en Login
 * @author Ricardo Guerra
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { Formik } from 'formik';
import * as Yup from 'yup';

import { PasswordService, ResponseHandlerService, SnackbarService } from '@services';
import { Icons, Layout, MUI, Typography } from '@styles';

class ForgotPasswordDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.values = {
      userName: '',
    };

    this.schema = Yup.object({
      userName: Yup.string()
        .min(3, i18n.t('FormsGeneralTexts.min3Chars'))
        .required('*'),
    });
  }

  /**
   * Solicita envío a correo electrónico para recuperación del password
   * @param user
   */
  getPassword = (user, resetForm, setSubmitting) => {
    const { userName } = user;
    const { onClose } = this.props;

    if (userName && userName.trim().length > 0) {
      PasswordService.retrieve({ Usuario: userName })
        .then((response) => {
          resetForm(this.values);
          ResponseHandlerService.success(response);
          onClose();
        })
        .catch((error) => {
          setSubmitting(false);
          ResponseHandlerService.error(error);
        });
    } else {
      setSubmitting(false);
      SnackbarService.error(i18n.t('ForgotPass.invalidUser'));
    }
  };

  render() {
    const { open, onClose } = this.props;
    return (
      <>
        <Formik
          validateOnMount
          validationSchema={this.schema}
          initialValues={this.values}
          initialErrors={this.values}
          initialTouched={this.values}
          onSubmit={(values, { resetForm, setSubmitting }) => {
            this.getPassword(values, resetForm, setSubmitting);
          }}
        >
          {(formikProps) => {
            return (
              <MUI.Dialog
                open={open}
                onClose={onClose}
                maxWidth="sm"
              >
                <MUI.DialogTitle>
                  <MUI.DialogBoxIcon>
                    <Icons.LockQuestion />
                  </MUI.DialogBoxIcon>
                  {i18n.t('ForgotPass.retrievePassword')}
                  <MUI.DialogBoxClose onClick={onClose}>
                    <Icons.Close />
                  </MUI.DialogBoxClose>
                </MUI.DialogTitle>

                <MUI.DialogContent>
                  <MUI.Box display="flex" padding="8px">
                    <Typography.Text>
                      {i18n.t('ForgotPass.retrieveMSG')}
                    </Typography.Text>
                  </MUI.Box>
                  {/* Usuario */}
                  <MUI.Box display="flex" padding="8px">
                    <MUI.TextFieldIcon
                      label={i18n.t('Login.userEnterpriseId')}
                      type="text"
                      name="userName"
                      value={formikProps.values.userName}
                      onBlur={formikProps.handleBlur}
                      onChange={formikProps.handleChange}
                      error={Boolean(formikProps.touched.userName && formikProps.errors.userName)}
                      helperText={formikProps.touched.userName && formikProps.errors.userName}
                      InputProps={{ startAdornment: (<Icons.Person />) }}
                    />
                  </MUI.Box>
                </MUI.DialogContent>

                <MUI.DialogActions>
                  <Layout.BoxRequired>
                    {`* ${i18n.t('FormsGeneralTexts.required')}`}
                  </Layout.BoxRequired>
                  <MUI.ButtonText onClick={onClose}>
                    {i18n.t('DialogConfirm.cancel')}
                  </MUI.ButtonText>
                  <MUI.ButtonCTA
                    type="button"
                    color="primary"
                    disabled={!formikProps.isValid || formikProps.isSubmitting}
                    onClick={formikProps.handleSubmit}
                  >
                    {i18n.t('ForgotPass.retrieve')}
                  </MUI.ButtonCTA>
                </MUI.DialogActions>
              </MUI.Dialog>
            );
          }}
        </Formik>
      </>
    );
  }
}

ForgotPasswordDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ForgotPasswordDialog;
